import { DialogActions, DialogContent, Typography } from '@mui/material'
import { DarkButton } from '@components'
import { useApprovalContext, useCommentsContext } from '@templates/approval/contexts'
import { ActionType } from '@templates/approval/contexts/approvalContext/types'
import { ActionType as CommentsActionType } from '@templates/approval/contexts/commentsContext/types'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  handleClose: () => void
}

export const ConfirmCancelDialogContent = ({ handleClose }: Props) => {
  const { dispatch, showApprovalRequestsTable } = useApprovalContext() ?? {
    dispatch: () => void {},
    showApprovalRequestsTable: () => void {},
  }
  const { dispatch: commentsDispatch } = useCommentsContext()

  return (
    <>
      <DialogContent css={css.content}>
        <Typography variant="body1">
          {t`You are about to cancel your review. If you wish to continue, all changes will be lost.`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <DarkButton onClick={handleClose}>{t`Cancel`}</DarkButton>
        <DarkButton onClick={handleConfirm} contained>
          {t`Confirm`}
        </DarkButton>
      </DialogActions>
    </>
  )

  function handleConfirm() {
    dispatch({
      type: ActionType.setReviewingRequest,
      payload: {
        reviewingRequest: null,
      },
    })

    commentsDispatch({
      type: CommentsActionType.clearComments,
    })

    showApprovalRequestsTable()
  }
}
